import { render, staticRenderFns } from "./pl-message-item.vue?vue&type=template&id=4e62a31a&"
import script from "./pl-message-item.vue?vue&type=script&lang=js&"
export * from "./pl-message-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports